import { PaymentTiming } from '@/features/dashboard/tfg/types/PaymentTiming.ts';

/** Stable ordering of payment-timing sub-rows within each pkt bucket. */
export const PAYMENT_TIMING_ORDER: PaymentTiming[] = [
  PaymentTiming.AFTER_TRIP_PAYMENT,
  PaymentTiming.BEFORE_TRIP_PAYMENT,
];

export const paymentTimingLabel: Record<PaymentTiming, string> = {
  [PaymentTiming.AFTER_TRIP_PAYMENT]:
    'wpłata przyjmowana po realizacji imprezy turystycznej',
  [PaymentTiming.BEFORE_TRIP_PAYMENT]: 'pozostałe przypadki',
};

export const getPaymentTimingLabel = (timing: PaymentTiming): string =>
  paymentTimingLabel[timing] ?? timing;
